import mapmate from '../../assets/images/mapmate/mapmate.png'
import httpmate from '../../assets/images/httpmate/httpmate-image.png'
import dockerJava from '../../assets/images/javaDockerWithOneDependency/dockerJava.png'
import HttpMateIntro from "./content/HttpMateIntro";
import MapMateIntro from "./content/MapMateIntro";
import JavaDockerWithOneDependency from "./content/JavaDockerWithOneDependency";
import * as ReadCounter from "./ReadCounter";

const articles = [
    {
        authorName: "nisabek",
        authorSocialLinkType: "twitter",
        uniqueKey: "httpMateIntro",
        header: "Introducing HttpMate",
        image: httpmate,
        tags: ["HTTP", "REST", "UseCases", "CleanCode", "CleanArchitecture", "SOLID", "DDD"],
        relativePath: "/httpmate-intro",
        date: "2019-06-09T09:01:01.449Z",
        readTime: 4,
        shortSummary: "Introducing our new HTTP framework. Non-invasive, flexible and ultra-extendable way of publishing your usecases.",
        summary: `HttpMate is a framework that allows you to "just publish your business logic as am HTTP endpoint". It's non-invasive, flexible and ultra-extendable. HttpMate offers you 3 modes of handling HTTP requests - UseCase-driven, low-level HTTP and event-driven request handling as well as mixing those modes to get the most out of the feature-rich framework.`,
        teaser: "Read on about why we had to create another HTTP framework and why it is good for you...",
        content: (HttpMateIntro)
    },
    {
        authorName: "nisabek",
        authorSocialLinkType: "twitter",
        uniqueKey: "httpMateMapMate",
        header: "(De)serialization and Validation of Custom Primitives and DTOs",
        image: mapmate,
        tags: ["AlwaysValid", "CleanCode", "DDD", "JSON", "Validation", "Serialization", "Deserialization", "HTTP", "REST"],
        relativePath: "/mapmate-intro",
        date: "2019-06-10T09:01:01.449Z",
        readTime: 6,
        shortSummary: "An intuitive serialization, deserialization and validation of Custom Primitives and Data Transfer Objects",
        summary: `MapMate solves the problem of (de)serialization and validation of Custom Primitives and Data Transfer Objects in a clean and non-invasive way. MapMate supports multiple formats, grouped validation messages, is integrated with HttpMate to provide you with the easiest and most powerful experience of writing modern microservices without compromising on things that matter.`,
        teaser: "Read on about extending Java with Custom Primitives, how can you keep your validation within your DTOs and produce user-friendly error messages...",
        content: (MapMateIntro)
    },
    {
        authorName: "nisabek",
        authorSocialLinkType: "twitter",
        uniqueKey: "javaDockerWithOneDependency",
        header: "Java Single Dependency Dockerized HTTP Endpoint",
        image: dockerJava,
        tags: ["Java", "Docker", "Tutorial", "SpringBoot", "Maven", "HTTP", "REST", "Endpoint", "HttpMate", "Debug", "Request"],
        relativePath: "/java-http-single-dependency-in-docker",
        date: "2019-06-25T16:01:01.449Z",
        readTime: 6,
        shortSummary: "Tutorial on how to build a simple Java-based dockerized application with only one dependency",
        summary: `This article is intended for beginners, who want to understand simple walkthrough for Dockerizing a java application. The vast majority of examples out there describing Java applications in a dockerized environment include the usage of heavy frameworks like Spring Boot.`,
        teaser: "We want to show here that you don't need much to get an endpoint running with Java in Docker...",
        content: (JavaDockerWithOneDependency)
    }
];

for (const article of articles) {
    const content = article.content;
    article.readTime = ReadCounter.readingTime(content());
}

const siteData = {
    title: "envimate's official blog. Our thoughts on automation, clean code, cloud, microservices, DevOps and all things tech.",
    description: "Writing and managing microservices using clean code and clean architecture principals. We build high quality software and opensource products."
};

export {articles, siteData};
